import React from "react";
import {AppBar, Tabs, Tab} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {BrowserRouter, Switch, Route, Link} from "react-router-dom";
import Playground from "./components/Playground";
import Simulation from "./components/Simulation";
import ColdFusion from "./components/ColdFusion";
const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
});

const App = () => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    function handleChange(event, newValue) {
        setValue(newValue);
    }

    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
        <div className={classes.root}>
            <AppBar position='static'>
                <Tabs
                    value={value}
                    onChange={handleChange}>
                    <Tab label="Playground" component={Link} to="/"/>
                    <Tab label="Simulation" component={Link} to="/simulation"/>
                    <Tab label="Cold Fusion" component={Link} to="/coldFusion" />
                </Tabs>
            </AppBar>
        </div>
        <Switch>
            <Route exact path="/" component={Playground} />
            <Route path="/simulation" component={Simulation} />
            <Route path="/coldFusion" component={ColdFusion} />
        </Switch>
        </BrowserRouter>
    )
};

export default App;